import { PaymentFrequency, PaymentFrequencyType } from '#modules/Budget/types/expense.types'
import { Chip, COLORS } from '@monthio/react-components'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

const getChipStyle = (
	frequency: (typeof PaymentFrequency)[keyof typeof PaymentFrequency],
) => {
	const createStyle = (backgroundColor: string, color: string) => {
		return {
			backgroundColor: backgroundColor,
			color: color,
			fontSize: '10px',
			fontWeight: 600,
		}
	}

	const FrequencyStyles = {
		[PaymentFrequency.Unknown]: createStyle(
			COLORS.GREY_SCALE.BACKGROUND_GREY,
			COLORS.TEXT_COLORS.DEFAULT,
		),
		[PaymentFrequency.EveryMonth]: createStyle('#FEEEE7', '#F46325'),
		[PaymentFrequency.EveryTwoWeeks]: createStyle(
			COLORS.OTHER_COLORS.AFFIRMATION_GREEN_LIGHT,
			COLORS.OTHER_COLORS.DARK_MONEY_GREEN_DARK,
		),
		[PaymentFrequency.EveryTwoMonths]: createStyle(
			COLORS.OTHER_COLORS.BRIGHT_BLUE_LIGHTER,
			COLORS.OTHER_COLORS.BRIGHT_BLUE_DARKER,
		),
		[PaymentFrequency.EveryThreeMonths]: createStyle(
			COLORS.OTHER_COLORS.BRIGHT_BLUE_LIGHTER,
			COLORS.OTHER_COLORS.BRIGHT_BLUE_DARK,
		),
		[PaymentFrequency.EverySixMonths]: createStyle(
			COLORS.BRAND_COLORS.LIGHT_PURPLE_LIGHTER,
			COLORS.BRAND_COLORS.LIGHT_PURPLE,
		),
		[PaymentFrequency.EveryYear]: createStyle(
			COLORS.BRAND_COLORS.PURPLE_LIGHTER,
			COLORS.BRAND_COLORS.PURPLE,
		),
	}

	return FrequencyStyles[frequency ?? PaymentFrequency.Unknown]
}

export const FrequencyChip: FC<{ frequency: PaymentFrequencyType }> = ({
	frequency,
}) => {
	const { t } = useTranslation()

	const frequencyText = t(
		`assetExpenses-expenseEstimate-occurrence-frequency-${frequency}`,
	)

	return (
		<Chip
			label={frequencyText}
			size="small"
			style={{
				...getChipStyle(frequency),
			}}
		/>
	)
}
